export const iconFontAwesomeNatureMountainCity = (
	<i className="fa-solid fa-mountain-city"></i>
);
